import styles from './notFound.module.scss';
import {Button} from "../../components/Button/Button";

export const NotFound = () =>{
  return <section className={styles.notFound}>
    <h2> 404 </h2>
    <h3> Tutaj nic nie ma :c </h3>
    <a href={"/"}><Button> Wróć do strony głównej </Button></a>
  </section>
}